module.exports = __webpack_public_path__ + "img/_ico1.c52f5a0b.svg";